import type { ComponentProps } from "react";
import { Root, Trigger, Portal, Content, Anchor } from "@radix-ui/react-popover";
import { cn } from "@/lib/utils";

function Popover({ ...props }: ComponentProps<typeof Root>) {
  return <Root data-slot="popover" {...props} />;
}

function PopoverTrigger({ ...props }: ComponentProps<typeof Trigger>) {
  return <Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: ComponentProps<typeof Content>) {
  return (
    <Portal>
      <Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        // pointer-events-auto: Dialog sets body { pointer-events: none } while open, so a
        // Popover portaled to body (outside DialogContent's own override) inherits it otherwise.
        className={cn(
          "bg-popover text-popover-foreground pointer-events-auto z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className
        )}
        {...props}
      />
    </Portal>
  );
}

function PopoverAnchor({ ...props }: ComponentProps<typeof Anchor>) {
  return <Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
